import Iknow99Router from './iknow99-router';

export default Iknow99Router;
